(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = Array.from(this.querySelectorAll('predictive-search'));

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const isSearchModalOpen = this.classList.contains('is-custom-search-open');
      const isPredictiveSearchOpen = this.predictiveSearches.some((search) => search.isOpen);

      if (isSearchModalOpen || isPredictiveSearchOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeDesktopMenu();
      this.closeMobileMenu();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');

      this.searchModals.forEach((modal) => {
        if (typeof modal.close === 'function') {
          modal.close(false);
        }
      });
    }

    closeDesktopMenu() {
      this.desktopMenus = this.desktopMenus || this.header.querySelectorAll('.custom-desktop-menu__details');
      this.desktopMenus.forEach((details) => details.removeAttribute('open'));
    }

    closeMobileMenu() {
      this.mobileMenus = this.mobileMenus || this.header.querySelectorAll('mobile-menu-nav');

      this.mobileMenus.forEach((menu) => {
        if (typeof menu.closeAll === 'function') {
          menu.closeAll();
        }
      });
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  if (!customElements.get('desktop-header-menu')) {
    customElements.define(
      'desktop-header-menu',
      class DesktopHeaderMenu extends HTMLElement {
        constructor() {
          super();

          this.onBodyClick = this.handleBodyClick.bind(this);
          this.onKeyUp = this.handleKeyUp.bind(this);
          this.onToggle = this.handleToggle.bind(this);
          this.onResize = this.updatePanelSize.bind(this);
          this.onScroll = this.updatePanelSize.bind(this);
        }

        connectedCallback() {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');

          if (this.details) {
            this.details.addEventListener('toggle', this.onToggle);
          }

          document.body.addEventListener('click', this.onBodyClick);
          document.body.addEventListener('keyup', this.onKeyUp);
          window.addEventListener('resize', this.onResize);
          window.addEventListener('scroll', this.onScroll, true);

          requestAnimationFrame(() => this.updatePanelSize());
          window.setTimeout(() => this.updatePanelSize(), 100);
          window.setTimeout(() => this.updatePanelSize(), 300);
          window.setTimeout(() => this.updatePanelSize(), 800);

          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => this.updatePanelSize());
          }
        }

        disconnectedCallback() {
          if (this.details) {
            this.details.removeEventListener('toggle', this.onToggle);
          }

          document.body.removeEventListener('click', this.onBodyClick);
          document.body.removeEventListener('keyup', this.onKeyUp);
          window.removeEventListener('resize', this.onResize);
          window.removeEventListener('scroll', this.onScroll, true);
        }

        handleToggle() {
          if (!this.summary || !this.details) return;

          this.summary.setAttribute('aria-expanded', this.details.hasAttribute('open') ? 'true' : 'false');
          this.updatePanelSize();
        }

        updatePanelSize() {
          const row = this.closest('.custom-desktop-header__menu-row');
          const header = this.closest('.custom-desktop-header');

          if (!row || !header) return;

          const group = row.querySelector('.custom-desktop-header__menu-group');

          if (!group) return;

          const headerRect = header.getBoundingClientRect();
          const groupRect = group.getBoundingClientRect();

          row.style.setProperty('--custom-panel-left', '0px');
          row.style.setProperty('--custom-panel-width', '100%');

          const iconsRightOffset = Math.max(0, headerRect.right - groupRect.right);
          header.style.setProperty('--custom-icons-right-offset', `${iconsRightOffset}px`);
        }

        handleBodyClick(event) {
          if (!this.details || !this.details.hasAttribute('open')) return;
          if (this.contains(event.target)) return;

          this.close(false);
        }

        handleKeyUp(event) {
          if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;

          this.close(true);
        }

        close(focusSummary = false) {
          if (!this.details) return;

          this.details.removeAttribute('open');

          if (this.summary) {
            this.summary.setAttribute('aria-expanded', 'false');

            if (focusSummary) {
              this.summary.focus();
            }
          }
        }
      }
    );
  }

  if (!customElements.get('desktop-scroll-nav')) {
    customElements.define(
      'desktop-scroll-nav',
      class DesktopScrollNav extends HTMLElement {
        constructor() {
          super();

          this.isDown = false;
          this.isDragging = false;
          this.startX = 0;
          this.scrollLeft = 0;
          this.activeDropdown = null;

          this.onPointerDown = this.handlePointerDown.bind(this);
          this.onPointerMove = this.handlePointerMove.bind(this);
          this.onPointerUp = this.handlePointerUp.bind(this);
          this.onClick = this.handleClick.bind(this);
          this.onDragStart = this.handleDragStart.bind(this);
          this.onMouseOver = this.handleMouseOver.bind(this);
          this.onResize = this.handleResize.bind(this);
          this.onScroll = this.handleScroll.bind(this);
        }

        connectedCallback() {
          this.viewport = this.querySelector('.custom-desktop-nav__viewport');

          if (!this.viewport) return;

          this.viewport.addEventListener('pointerdown', this.onPointerDown);
          this.viewport.addEventListener('pointermove', this.onPointerMove);
          this.viewport.addEventListener('pointerup', this.onPointerUp);
          this.viewport.addEventListener('pointerleave', this.onPointerUp);
          this.viewport.addEventListener('click', this.onClick, true);
          this.viewport.addEventListener('dragstart', this.onDragStart);
          this.viewport.addEventListener('mouseover', this.onMouseOver);
          this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

          window.addEventListener('resize', this.onResize);
          window.addEventListener('scroll', this.onScroll, true);

          requestAnimationFrame(() => this.updateRelatedMenu());
        }

        disconnectedCallback() {
          if (!this.viewport) return;

          this.viewport.removeEventListener('pointerdown', this.onPointerDown);
          this.viewport.removeEventListener('pointermove', this.onPointerMove);
          this.viewport.removeEventListener('pointerup', this.onPointerUp);
          this.viewport.removeEventListener('pointerleave', this.onPointerUp);
          this.viewport.removeEventListener('click', this.onClick, true);
          this.viewport.removeEventListener('dragstart', this.onDragStart);
          this.viewport.removeEventListener('mouseover', this.onMouseOver);
          this.viewport.removeEventListener('scroll', this.onScroll);

          window.removeEventListener('resize', this.onResize);
          window.removeEventListener('scroll', this.onScroll, true);
        }

        handleMouseOver(event) {
          const item = event.target.closest('.custom-desktop-nav__item--has-dropdown');

          if (!item || !this.contains(item)) return;

          const dropdown = item.querySelector('.custom-desktop-nav__dropdown');

          if (!dropdown) return;

          this.activeDropdown = {
            item,
            dropdown
          };

          this.positionDropdown(item, dropdown);
        }

        positionDropdown(item, dropdown) {
          const rect = item.getBoundingClientRect();

          dropdown.style.setProperty('--custom-dropdown-left', `${rect.left + rect.width / 2}px`);
          dropdown.style.setProperty('--custom-dropdown-top', `${rect.bottom}px`);
        }

        updateActiveDropdown() {
          if (!this.activeDropdown) return;

          this.positionDropdown(this.activeDropdown.item, this.activeDropdown.dropdown);
        }

        updateRelatedMenu() {
          const row = this.closest('.custom-desktop-header__menu-row');
          const menu = row ? row.querySelector('desktop-header-menu') : null;

          if (menu && typeof menu.updatePanelSize === 'function') {
            menu.updatePanelSize();
          }
        }

        handleResize() {
          this.updateActiveDropdown();
          this.updateRelatedMenu();
        }

        handleScroll() {
          this.updateActiveDropdown();
          this.updateRelatedMenu();
        }

        handlePointerDown(event) {
          if (event.pointerType !== 'mouse') return;

          this.isDown = true;
          this.isDragging = false;
          this.startX = event.pageX;
          this.scrollLeft = this.viewport.scrollLeft;
          this.viewport.classList.add('is-dragging-ready');
        }

        handlePointerMove(event) {
          if (!this.isDown || event.pointerType !== 'mouse') return;

          const distance = event.pageX - this.startX;

          if (Math.abs(distance) > 5) {
            this.isDragging = true;
            this.viewport.classList.add('is-dragging');
          }

          if (this.isDragging) {
            event.preventDefault();
            this.viewport.scrollLeft = this.scrollLeft - distance;
            this.updateRelatedMenu();
          }
        }

        handlePointerUp() {
          this.isDown = false;

          if (this.viewport) {
            this.viewport.classList.remove('is-dragging-ready', 'is-dragging');
          }

          window.setTimeout(() => {
            this.isDragging = false;
          }, 0);
        }

        handleClick(event) {
          if (!this.isDragging) return;

          event.preventDefault();
          event.stopPropagation();
        }

        handleDragStart(event) {
          event.preventDefault();
        }
      }
    );
  }

  if (!customElements.get('mobile-menu-nav')) {
    customElements.define(
      'mobile-menu-nav',
      class MobileMenuNav extends HTMLElement {
        constructor() {
          super();

          this.portal = null;
          this.panelRecords = [];
          this.activeRecord = null;
          this.viewport = null;

          this.onClick = this.handleClick.bind(this);
          this.onDocumentClick = this.handleDocumentClick.bind(this);
          this.onWindowScroll = this.handleWindowScroll.bind(this);
          this.onKeyUp = this.handleKeyUp.bind(this);
          this.onResize = this.handleResize.bind(this);
          this.onViewportScroll = this.handleViewportScroll.bind(this);
          this.onPortalClick = this.handlePortalClick.bind(this);
        }

        connectedCallback() {
          this.viewport = this.querySelector('.custom-mobile-nav__viewport');
          this.triggers = Array.from(this.querySelectorAll('[data-mobile-menu-trigger]'));

          this.mountPortal();

          this.addEventListener('click', this.onClick);
          document.addEventListener('click', this.onDocumentClick);
          window.addEventListener('scroll', this.onWindowScroll, { passive: true });
          window.addEventListener('resize', this.onResize);
          document.addEventListener('keyup', this.onKeyUp);

          if (this.viewport) {
            this.viewport.addEventListener('scroll', this.onViewportScroll, { passive: true });
          }

          if (this.portal) {
            this.portal.addEventListener('click', this.onPortalClick);
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          document.removeEventListener('click', this.onDocumentClick);
          window.removeEventListener('scroll', this.onWindowScroll);
          window.removeEventListener('resize', this.onResize);
          document.removeEventListener('keyup', this.onKeyUp);

          if (this.viewport) {
            this.viewport.removeEventListener('scroll', this.onViewportScroll);
          }

          if (this.portal) {
            this.portal.removeEventListener('click', this.onPortalClick);
          }

          this.closeAll();
          this.restorePanels();

          if (this.portal && this.portal.parentNode) {
            this.portal.parentNode.removeChild(this.portal);
          }

          this.portal = null;
          this.panelRecords = [];
          this.activeRecord = null;
        }

        mountPortal() {
          const records = [];

          this.triggers.forEach((trigger) => {
            const item = trigger.closest('.custom-mobile-nav__item');
            const panel = item ? item.querySelector('[data-mobile-menu-panel]') : null;

            if (!item || !panel) return;

            const marker = document.createComment('custom-mobile-dropdown-origin');
            panel.parentNode.insertBefore(marker, panel);

            records.push({
              item,
              trigger,
              panel,
              marker
            });
          });

          if (!records.length) return;

          const portal = document.createElement('div');
          portal.className = 'custom-mobile-dropdown-portal';
          portal.setAttribute('aria-hidden', 'true');

          records.forEach((record) => {
            portal.appendChild(record.panel);
          });

          document.body.appendChild(portal);

          this.portal = portal;
          this.panelRecords = records;
        }

        restorePanels() {
          this.panelRecords.forEach((record) => {
            const { panel, marker } = record;

            panel.classList.remove('is-portal-open');

            if (marker && marker.parentNode) {
              marker.parentNode.insertBefore(panel, marker.nextSibling);
              marker.parentNode.removeChild(marker);
            }
          });
        }

        getRecordByTrigger(trigger) {
          return this.panelRecords.find((record) => record.trigger === trigger) || null;
        }

        positionPortal() {
          if (!this.portal) return;

          const rowRect = this.getBoundingClientRect();
          const top = Math.max(0, Math.ceil(rowRect.bottom));

          this.portal.style.setProperty('--custom-mobile-dropdown-top', `${top}px`);
        }

        openRecord(record) {
          if (!record || !this.portal) return;

          this.positionPortal();

          record.item.classList.add('is-open');
          record.trigger.setAttribute('aria-expanded', 'true');
          record.panel.classList.add('is-portal-open');

          this.portal.setAttribute('aria-hidden', 'false');
          this.activeRecord = record;
        }

        handleClick(event) {
          const trigger = event.target.closest('[data-mobile-menu-trigger]');

          if (!trigger || !this.contains(trigger)) return;

          event.preventDefault();

          const record = this.getRecordByTrigger(trigger);
          const isOpen = Boolean(
            record
            && this.activeRecord === record
            && record.panel.classList.contains('is-portal-open')
          );

          this.closeAll();

          if (!record || isOpen) return;

          this.openRecord(record);
        }

        handlePortalClick(event) {
          if (!this.portal || !this.portal.contains(event.target)) return;

          const link = event.target.closest('a[href]');

          if (link) {
            this.closeAll();
          }
        }

        handleDocumentClick(event) {
          if (this.contains(event.target)) return;
          if (this.portal && this.portal.contains(event.target)) return;

          this.closeAll();
        }

        handleWindowScroll() {
          this.closeAll();
        }

        handleViewportScroll() {
          this.closeAll();
        }

        handleResize() {
          this.closeAll();
        }

        handleKeyUp(event) {
          if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;

          const trigger = this.activeRecord ? this.activeRecord.trigger : null;

          this.closeAll();

          if (trigger) {
            trigger.focus();
          }
        }

        closeAll() {
          this.panelRecords.forEach((record) => {
            record.item.classList.remove('is-open');
            record.trigger.setAttribute('aria-expanded', 'false');
            record.panel.classList.remove('is-portal-open');
          });

          if (this.portal) {
            this.portal.setAttribute('aria-hidden', 'true');
          }

          this.activeRecord = null;
        }
      }
    );
  }


  } catch(e) { console.error(e); }
})();
})();
